import { styled } from '../../theme';
import { Box, Text } from '../../primitives';
import { Column } from '../Column';

export const Wrapper = styled(Column)`
	padding: ${({ theme }) => theme.space.sm}px;
	border-radius: ${({ theme }) => theme.rounding.md}px;
	background: ${({ theme }) => theme.color.greenSurfaceMuted.base};
	text-align: left;
	gap: ${({ theme }) => theme.space.xs}px;
`;

export const Title = styled(Text).attrs((props) => ({
	...props,
	style: 'bold',
	element: 'span',
}))`
	display: block;
	color: ${({ theme }) => theme.color.darkGray.base};
`;

export const Content = styled(Box)`
	width: 100%;
`;
